var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #707070;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10206",
    "data-name": "Group 10206",
    transform: "translate(-1255 -557)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2775",
    "data-name": "Rectangle 2775",
    className: "cls-1",
    width: 15,
    height: 15,
    rx: 7.5,
    transform: "translate(1255 557)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8141",
    "data-name": "Group 8141",
    transform: "translate(1259 561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    className: "cls-2",
    d: "M62-1514h7.5",
    transform: "translate(-62 1517.755)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.0b36b0af18ff24488cf8039e17237893.svg";
export { ForwardRef as ReactComponent };